export default {
  // Header
  "contact": "தொடர்பு",
  "us": "எங்களை",
  "contact_description": "ஏதேனும் கேள்வி, கருத்து, அல்லது தனிப்பட்ட ஜோதிட ஆலோசனை வேண்டுமா? எங்களை தொடர்பு கொள்ளுங்கள் — 24–48 மணிநேரத்திற்குள் பதிலளிப்போம்.",

  // Contact Info Section
  "email": "மின்னஞ்சல்",
  "phone_whatsapp": "WhatsApp",
  "chat_on_whatsapp": "WhatsApp-ல் அரட்டை",
  "follow_us": "எங்களை பின்தொடருங்கள்",

  // Form Labels
  "full_name": "முழுப் பெயர்",
  "email_address": "மின்னஞ்சல் முகவரி",
  "phone_number": "தொலைபேசி எண்",
  "subject": "தலைப்பு",
  "message": "செய்தி",

  // Form Placeholders
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "email_placeholder": "you@email.com",
  "phone_placeholder": "விருப்பத்தேர்வு: +91 xxxxx-xxxxx",
  "subject_placeholder": "நாங்கள் எதில் உதவலாம்?",
  "message_placeholder": "உங்கள் ஜோதிட தேவைகளில் எவ்வாறு உதவலாம் என்பதை சொல்லுங்கள்...",

  // Form Actions
  "send_message": "செய்தியை அனுப்புங்கள்",
  "message_sent_success": "செய்தி அனுப்பப்பட்டது! ✓",
  "thank_you_message": "எங்களை தொடர்பு கொண்டதற்கு நன்றி! 24–48 மணிநேரத்திற்குள் தொடர்பு கொள்கிறோம்."
}
